export enum Routes {
  rootUrl = '/',

  // Public
  report = 'report/:id',
  task = 'task',
  interactiveVideo = 'interactiveVideo',
  annotationPicture = 'annotationPicture',
}
